import { render } from "./Cargando.vue?vue&type=template&id=8457de54&ts=true"
import script from "./Cargando.vue?vue&type=script&lang=ts"
export * from "./Cargando.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/common/infrastructure/componentes/base/common/cargando/Cargando.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8457de54"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8457de54', __exports__)) {
    api.reload('8457de54', __exports__)
  }
  
  module.hot.accept("./Cargando.vue?vue&type=template&id=8457de54&ts=true", () => {
    api.rerender('8457de54', render)
  })

}


export default __exports__